import { LEARNING_LANGUAGE_OPTIONS, toLearningLanguage } from "@/constants/langcraftLanguages";

const languageFlagOverrides = {
  ar: "🇸🇦",
  bn: "🇧🇩",
  de: "🇩🇪",
  en: "🇺🇸",
  "en-gb": "🇬🇧",
  "en-gb-x-rp": "🇬🇧",
  "en-uk": "🇬🇧",
  "en-us": "🇺🇸",
  es: "🇪🇸",
  "es-419": "🌎",
  "es-mx": "🇲🇽",
  fr: "🇫🇷",
  "fr-be": "🇧🇪",
  "fr-ch": "🇨🇭",
  hi: "🇮🇳",
  it: "🇮🇹",
  ja: "🇯🇵",
  ko: "🇰🇷",
  pt: "🇵🇹",
  "pt-br": "🇧🇷",
  ru: "🇷🇺",
  zh: "🇨🇳",
  "zh-cn": "🇨🇳",
  "zh-tw": "🇹🇼",
};

const buildFlagFromRegion = (region) => {
  if (!region || region.length !== 2) {
    return undefined;
  }

  const upper = region.toUpperCase();
  const codePoints = [...upper].map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

export const getFlagForLanguage = (languageCode) => {
  if (!languageCode) {
    return "🏳️";
  }

  const normalized = languageCode.toLowerCase();

  // LangCraft languages and accents carry their own flag (avoids guessing
  // from codes like "ca-va", which would otherwise read as Vatican City).
  const option = LEARNING_LANGUAGE_OPTIONS.find(
    (entry) => entry.code === toLearningLanguage(normalized)
  );
  if (option && (option.isDialect || !languageFlagOverrides[normalized])) {
    return option.flag;
  }

  if (languageFlagOverrides[normalized]) {
    return languageFlagOverrides[normalized];
  }

  const parts = normalized.split(/[-_]/).filter(Boolean);

  const regionPart = parts.find(
    (part) => /^[a-z]{2}$/.test(part) && part !== "x"
  );
  if (regionPart) {
    const flagFromRegion = buildFlagFromRegion(regionPart);
    if (flagFromRegion) {
      return flagFromRegion;
    }
  }

  const baseLanguage = parts[0];
  if (languageFlagOverrides[baseLanguage]) {
    return languageFlagOverrides[baseLanguage];
  }

  return "🏳️";
};
